import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {VocabularyComponent} from './components/vocabulary/vocabulary.component';
import {LoginComponent} from './components/user/login/login.component';
import {AuthGuard} from './guards/auth.guard';
import {ProfileComponent} from './components/user/profile/profile.component';
import {UserManagementComponent} from './components/user/user-management/user-management.component';
import {ImprintComponent} from './components/static-pages/imprint/imprint.component';
import {HomeComponent} from './components/static-pages/home/home.component';
import {ResetTokenComponent} from './components/user/reset-token/reset-token.component';
import {TextPatternComponent} from './components/text-pattern/text-pattern.component';
import {TextPatternDetailComponent} from './components/text-pattern/text-pattern-detail/text-pattern-detail.component';
import {GrammarComponent} from "./components/grammar/grammar.component";
import {TextTypeComponent} from './components/text-type/text-type.component';
import {VerbalActionComponent} from './components/verbal-action/verbal-action.component';
import {CanDoStatementComponent} from './components/can-do-statement/can-do-statement.component';
import {SearchResultsComponent} from './components/search-results/search-results.component';
import {FolderOverviewComponent} from './components/folders/folder-overview/folder-overview.component';
import {FolderDetailComponent} from './components/folders/folder-detail/folder-detail.component';
import {NotificationsComponent} from './components/notifications/notifications.component';
// TODO remove AuthGuard for release
const routes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'login', component: LoginComponent},
  {path: 'imprint', component: ImprintComponent},
  {path: 'reset', component: ResetTokenComponent},
  {path: 'wortschatz', component: VocabularyComponent, canActivate: [AuthGuard]},
  {path: 'textmuster', component: TextPatternComponent, canActivate: [AuthGuard]},
  {path: 'textmuster/:id', component: TextPatternDetailComponent, canActivate: [AuthGuard]},
  {path: 'textsorten', component: TextTypeComponent, canActivate: [AuthGuard]},
  {path: 'grammatik', component: GrammarComponent, canActivate: [AuthGuard]},
  {path: 'kannbeschreibungen', component: CanDoStatementComponent, canActivate: [AuthGuard]},
  {path: 'sprachhandlungen', component: VerbalActionComponent, canActivate: [AuthGuard]},
  {path: 'suche', component: SearchResultsComponent, canActivate: [AuthGuard]},
  {
    path: 'account', component: ProfileComponent,
    canActivate: [AuthGuard], data: {roles: ['ROLE_ADMIN', 'ROLE_USER_PAID', 'ROLE_USER_FREE']}
  },
  {
    path: 'sammelmappen', component: FolderOverviewComponent,
    canActivate: [AuthGuard], data: {roles: ['ROLE_ADMIN', 'ROLE_USER_PAID']}
  },
  {
    path: 'sammelmappen/:id', component: FolderDetailComponent,
    canActivate: [AuthGuard], data: {roles: ['ROLE_ADMIN', 'ROLE_USER_PAID']}
  },
  {
    path: 'benachrichtigungen', component: NotificationsComponent,
    canActivate: [AuthGuard], data: {roles: ['ROLE_ADMIN', 'ROLE_USER_PAID', 'ROLE_USER_FREE']}
  },
  {
    path: 'nutzerverwaltung', component: UserManagementComponent,
    canActivate: [AuthGuard], data: {roles: ['ROLE_ADMIN']}
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
